var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.1107V3.77734M10 13.1107L7.66667 10.7774M10 13.1107L12.3333 10.7774M6.11111 7.66624H5.48889C4.6177 7.66624 4.1821 7.66624 3.84935 7.83579C3.55665 7.98493 3.31868 8.2229 3.16955 8.5156C3 8.84835 3 9.28395 3 10.1551V13.7329C3 14.6041 3 15.0397 3.16955 15.3725C3.31868 15.6652 3.55665 15.9031 3.84935 16.0523C4.1821 16.2218 4.6177 16.2218 5.48889 16.2218H14.5111C15.3823 16.2218 15.8179 16.2218 16.1507 16.0523C16.4433 15.9031 16.6813 15.6652 16.8305 15.3725C17 15.0397 17 14.6041 17 13.7329V10.1551C17 9.28395 17 8.84835 16.8305 8.5156C16.6813 8.2229 16.4433 7.98493 16.1507 7.83579C15.8179 7.66624 15.3823 7.66624 14.5111 7.66624H13.8889",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDownload;